import type { CtaBlockPayload } from '@opinix-cloud/shared';
import { EarlyAccessForm } from '../components/EarlyAccessForm';

interface FinalCTAProps {
  onRequestDemo: () => void;
  content: CtaBlockPayload;
}

export function FinalCTA({ onRequestDemo, content }: FinalCTAProps): JSX.Element {
  return (
    <section
      id="early-access"
      className="bg-steel-50 py-24 sm:py-32 border-t border-steel-200"
    >
      <div className="container-x">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20">
          <div>
            {content.eyebrow && <p className="eyebrow">{content.eyebrow}</p>}
            <h2 className="mt-3 section-title">{content.heading}</h2>
            {content.blurb && (
              <p className="mt-5 text-lg text-steel-600 leading-relaxed">
                {content.blurb}
              </p>
            )}
            <div className="mt-8">
              <button
                type="button"
                onClick={onRequestDemo}
                className="btn btn-primary"
              >
                {content.primaryCtaLabel ?? 'Request a demo'}
                <svg
                  aria-hidden="true"
                  className="ml-2 h-4 w-4"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M4 10h12m-4-4 4 4-4 4"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
              {content.primaryCtaFootnote && (
                <p className="mt-3 text-sm text-steel-500">
                  {content.primaryCtaFootnote}
                </p>
              )}
            </div>
          </div>
          {content.secondaryCard && (
            <div className="rounded-xl border border-steel-200 bg-white p-8 shadow-sm">
              <h3 className="text-lg font-bold text-navy-900 tracking-tight">
                {content.secondaryCard.heading}
              </h3>
              {content.secondaryCard.blurb && (
                <p className="mt-2 text-sm text-steel-600">
                  {content.secondaryCard.blurb}
                </p>
              )}
              <div className="mt-6">
                <EarlyAccessForm />
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
